// @flow

import * as React from 'react';
import {useContext, useReducer} from 'react';
import type {SearchResult} from 'docs/data';
import {useAccount} from 'docs/data';
import {contextStubFunction} from 'docs/util';
import {SearchReducer} from './SearchReducer';
import {loadSearchResults} from './actions/loadSearchResults';
import type {SearchReducerState} from './SearchReducer';

export type SearchActions = {|
  loadSearchResults: (query: string) => Promise<Array<SearchResult>>,
|};

export type SearchContextType = {
  ...SearchReducerState,
  ...SearchActions,
};

const SearchContext = React.createContext<SearchContextType>({
  isLoading: false,
  query: '',
  results: ([]: Array<SearchResult>),
  loadSearchResults: contextStubFunction('Search'),
});

type SearchProviderProps = {|
  children: React.Node,
|};

export const SearchProvider = ({children}: SearchProviderProps) => {
  const {account} = useAccount();
  const [state, dispatch] = useReducer(SearchReducer, {
    query: '',
    results: [],
    isLoading: false,
  });

  const context = {
    ...state,
    loadSearchResults: loadSearchResults(dispatch, account),
  };

  return (
    <SearchContext.Provider value={context}>{children}</SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};
